import React, { useEffect, useState } from 'react'
import { Divider, Popup, Table } from 'semantic-ui-react';

import { listaFuncionariosNoPrecalificados, listaPendientesAutorizar, precalificacionesPrecalificador } from '../../utils/Datos';

export const InfoValidadosEvaluados = (
    {
        id_process=null,
        id_officer=null,
        totalParticipantes=0,
        noEvaluados=0,
        noValidados=0,
        etapa=null,
        setpendientes,
        setCargandoDatos,
        setevaluadas,
        setvalidadas,
        titulo_evaluados=''
    }
) => {


 
    const [id_funcionario, setid_funcionario] = useState(null)
    const [etapaComparar, setetapa] = useState(null)

    useEffect(() => {
            if (etapaComparar!=null) {
                setCargandoDatos(true);
                
                let payload = {
                id_process: id_process,
                id_officer: id_officer,
                };
                
                precalificacionesPrecalificador(id_process,id_officer).then((datos) => {
                    let datos_temp=[];
                    datos.map((data,index)=>{
                        if (data["name"]==etapaComparar) {
                            datos_temp.push(data);
                        }
                    })
              
                    setpendientes(datos_temp);
                    setCargandoDatos(false);
                    setetapa(null);
                });
                setid_funcionario(null);
            }
            
       
  
    }, [etapaComparar])
    

    const evaluados = totalParticipantes - noEvaluados;
    const porcentaje_evaluados = totalParticipantes > 0 && evaluados > 0 ? (evaluados * 100) / totalParticipantes : 0;

    const validados = totalParticipantes - noValidados;
    const porcentaje_validados = totalParticipantes > 0 && validados > 0 ? (validados * 100) / totalParticipantes : 0;


    return (
        <>
            <b>{Math.round(porcentaje_evaluados)}%</b><br />
            <a
                data-bs-toggle="modal"
                data-bs-target={`#modal_pendientes`}
                href="#"
                onClick={()=>{
                    setid_funcionario(id_officer)
                    setetapa(etapa);
                    setevaluadas(true);
                    setvalidadas(false);
                }}

            >
            {evaluados==totalParticipantes ?     <Popup content={'Todos los participantes han sido evaluados'} trigger={<i className='mr-2 text-success fas fa-check'></i>} /> :
                                                <Popup content={noEvaluados+' participantes no han sido evaluados'} trigger={<i className='mr-2 text-warning fas fa-exclamation-triangle'></i>} /> 
            }
            {evaluados} / {totalParticipantes} {titulo_evaluados} 
            </a>

            <Divider section />

            <b>{Math.round(porcentaje_validados)}%</b><br />
            
            {validados==totalParticipantes ?     <Popup content={'Todos los participantes han validado su evaluación'} trigger={<i className='mr-2 text-success fas fa-check'></i>} /> :
                                                <Popup content={noValidados+' participantes no han validado su evaluación'} trigger={<i className='mr-2 text-warning fas fa-exclamation-triangle'></i>} /> 
            }
            <a
             data-bs-toggle="modal"
             data-bs-target={`#modal_pendientes`}
             href="#"
             onClick={()=>{
                 setid_funcionario(id_officer)
                 setetapa(etapa);
                 setevaluadas(false);
                 setvalidadas(true);
             }}
            >{validados} / {totalParticipantes} funcionarios han validado 
            </a>

            
        </>
    )
}
